import {React, useState, useEffect} from 'external/react'
import {clsx, styled, TextField} from 'external/material'

const StyledField = styled(TextField)(gardeInputStyles)

export default function GradeInput (props) {

  const {total, onGradeChange, className} = props

  const [state, setState] = useState({value: props.value === null ? null : props.value, sentValue: props.value})

  function handleBlur () {
    if (state.value != state.sentValue) {
      onGradeChange && onGradeChange(state.value)
      setState({...state, sentValue: state.value})
    }
  }

  function handleChange (e) {
    const value = e.target.value == '' ? null : parseInt(e.target.value)
    setState({...state, value})
  }

  useEffect(() => {
    if (props.value != state.value) {
      setState({value: props.value || null, sentValue: props.value})
    }
  }, [props.value])

  return (
    <StyledField
      className={clsx('gradeInput', className)}
      InputProps={{inputProps: {min: 0, max: total}}}
      value={state.value === null ? '' : state.value}
      type="number"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

function gardeInputStyles(){
  return {
    "& fieldset": {
      marginTop: 3,
      borderWidth: 0
    },
    "& input": {
      textAlign: 'center',
      padding: 0,
      marginRight: 5,
      paddingLeft: 11
    },
    "& .MuiOutlinedInput-root": {
      marginTop: '15px',
      fontSize: '10.5pt',
      height: '35px',
      width: '65px'
    }
  }
}
